// extracted by mini-css-extract-plugin
export default {"project_title":"projectStyle_project_title__ynzeg","user_title":"projectStyle_user_title__lOe5T"};